function findLabelTeaspoon(value) {
  const TeaspoonList = [
    {
      label: `少々`,
      value: '0.1',
    },
    {
      label: `1/4`,
      value: '0.25',
    },
    {
      label: `1/3`,
      value: '0.33',
    },
    {
      label: `1/2`,
      value: '0.5',
    },
    {
      label: `1`,
      value: '1.0',
    },
    {
      label: `1.5`,
      value: '1.5',
    },
    {
      label: `2`,
      value: '2.0',
    },
    {
      label: `2.5`,
      value: '2.5',
    },
    {
      label: `3`,
      value: '3.0',
    },
  ];

  const teaspoon = TeaspoonList.find(item => Number(item.value) === Number(value));
  return teaspoon ? teaspoon.label : Number(value);
}